import { render, staticRenderFns } from "./wt-paged-table.vue?vue&type=template&id=5b997be6"
import script from "./wt-paged-table.vue?vue&type=script&lang=js"
export * from "./wt-paged-table.vue?vue&type=script&lang=js"
import style0 from "./wt-paged-table.vue?vue&type=style&index=0&id=5b997be6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports